import React, { useEffect, useState } from "react";
import "./widgetHtml.css";

const SubscriptionWidgetHtml = (props) => {
    const { formData, translationFormData, allStyles } = props;
    const [widgetHtml, setWidgetHtml] = useState();
    const [customStyle, setCustomStyle] = useState('');

    const getTranslation = (tkey, toReplace = {}) => {
        let translation = translationFormData?.find((t) => t.key == tkey)?.value
        if (translation) {
            Object.keys(toReplace)?.map((tr) => {
                translation = translation?.replace(`{{${tr}}}`, toReplace[tr])
            })
        }
        return translation
    }

    const changeStyle = () => {
        let css = ''
        for (const category of Object.keys(allStyles)) {
            for (const field of allStyles[category]["fields"]) {
                const class_name = allStyles[category]["class"];
                const css_property = field["css_property"];
                let value = '';
                field.sub_fields?.map((sf, i) => {
                    if (field.sub_fields?.length == 5) {
                        if (i != 4) {
                            value += ` ${sf.value}${field.sub_fields?.[4]?.value} `
                        }
                    } else {
                        value += sf.value;
                    }
                })

                if (value) {
                    css += `${class_name} {\n${css_property}: ${value} !important;\n}\n`;
                }
            }
        }
        setCustomStyle(css);
    }

    useEffect(() => {
        changeStyle();
    }, [allStyles])

    useEffect(() => {
        setWidgetHtml(
            `
            <fieldset class="chargezen-plan-picker " chargezen-plan-picker="8130464383278" chargezen-auto-init="" chargezen-discount-format="percent" chargezen-main-product="">
            ${formData?.show_purchase ? `<div class="chargezen-purchase-options-label">${getTranslation("purchase_option_label")}</div>` : ``}    
            ${formData?.purchase_options_order == "display_one_time_purchase" ?
                ``
                :
                ``
            }  
                <div class="chargezen_plans_options_wrapper">   
                                 
                    <div class="chargezen-group-container chargezen-group-container--available ${formData?.default_selected_option == "one_time_purchase" ? "chargezen-group-container--selected" : ""}">
                        <input class="chargezen-group-input" name="one_time_radio" type="radio"  ${formData?.default_selected_option == "one_time_purchase" ? "checked" : "disabled"}>
                        <label class="chargezen-group-label" for="chargezen-one-time-8130464383278">
                            <div class="chargezen-group-topline">
                                <div class="chargezen-radio__container">
                            
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        
                                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
                                        <circle class="chargezen-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
                                        
                                    </svg>
                
                                </div>
                                One time purchase
                                <div class="chargezen-price">
                                    <span class="money">$1,025.00 USD</span>
                                </div>
                            </div>
                        </label>
                    </div>
                
                    <div class="chargezen-group-container chargezen-group-container--available ${formData?.default_selected_option == "subscription" ? "chargezen-group-container--selected" : ""}">
                        <input class="chargezen-group-input" name="subscription_radio" type="radio"  ${formData?.default_selected_option == "subscription" ? "checked" : "disabled"}>
                        <label class="chargezen-group-label" for="chargezen-selling-plan-group-1-8130464383278">
                            <div class="chargezen-group-topline">
                                <div class="chargezen-radio__container">                            
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        
                                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
                                        <circle class="chargezen-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
                                        
                                    </svg>                
                                </div>
                                <div class="chargezen-group-title">
                                    Prepay  
                                    <span class="chargezen-subscription-group-discount-badge">
                                        Save 10%
                                    </span>
                                </div>                
                                <div class="chargezen-price">
                                    <span class="money">$1,025.00 USD</span>
                                </div>
                            </div>
                            <div class="chargezen-group-content">
                                <select chargezen-selling-plans="ca3a12ea12ff899608c7d8911f3f4c967670703b" class="chargezen-frequency">
                                    <option value="689949016366" selected="">
                                        1 week 
                                    </option>
                                    <option value="689949049134">
                                        chargentesting2                                    
                                    </option>                                
                                </select>
                            </div>                        
                        </label>
                    </div>
                    
                
                
                
                </div>
                <div class="chargezen_description_wrapper">test descriptionfsdfsdfsd</div>
                
                <div class="chargezen-tooltip">
                    <div class="chargezen-tooltip-image">
                        <svg
                        width="15"
                        height="15"
                        viewBox="0 0 90 90"
                        xmlns="http://www.w3.org/2000/svg"
                        class="tooltip_subscription_svg"
                        >
                        <path
                            d="M45 0C20.1827 0 0 20.1827 0 45C0 69.8173 20.1827 90 45 90C69.8173 90 90 69.8174 90 45C90.0056 44.6025 89.9322 44.2078 89.7839 43.8389C89.6357 43.47 89.4156 43.1342 89.1365 42.8511C88.8573 42.568 88.5247 42.3432 88.158 42.1897C87.7912 42.0363 87.3976 41.9573 87 41.9573C86.6024 41.9573 86.2088 42.0363 85.842 42.1897C85.4753 42.3432 85.1427 42.568 84.8635 42.8511C84.5844 43.1342 84.3643 43.47 84.2161 43.8389C84.0678 44.2078 83.9944 44.6025 84 45C84 66.5748 66.5747 84 45 84C23.4253 84 6 66.5747 6 45C6 23.4254 23.4253 6 45 6C56.1538 6 66.3012 10.5882 73.4375 18H65.4062C65.0087 17.9944 64.614 18.0678 64.2451 18.2161C63.8762 18.3643 63.5405 18.5844 63.2573 18.8635C62.9742 19.1427 62.7494 19.4753 62.596 19.842C62.4425 20.2088 62.3635 20.6024 62.3635 21C62.3635 21.3976 62.4425 21.7912 62.596 22.158C62.7494 22.5247 62.9742 22.8573 63.2573 23.1365C63.5405 23.4156 63.8762 23.6357 64.2451 23.7839C64.614 23.9322 65.0087 24.0056 65.4062 24H79.8125C80.6081 23.9999 81.3711 23.6838 81.9337 23.1212C82.4963 22.5586 82.8124 21.7956 82.8125 21V6.59375C82.821 6.18925 82.7476 5.78722 82.5966 5.41183C82.4457 5.03644 82.2205 4.69545 81.9344 4.40936C81.6483 4.12327 81.3073 3.898 80.9319 3.7471C80.5565 3.5962 80.1545 3.52277 79.75 3.53125C79.356 3.53941 78.9675 3.62511 78.6067 3.78344C78.2458 3.94177 77.9197 4.16963 77.6469 4.45402C77.3741 4.73841 77.16 5.07375 77.0168 5.44089C76.8737 5.80803 76.8042 6.19977 76.8125 6.59375V12.875C68.6156 4.86282 57.3081 0 45 0ZM43.75 20.75C43.356 20.7582 42.9675 20.8439 42.6067 21.0022C42.2458 21.1605 41.9197 21.3884 41.6469 21.6728C41.3741 21.9572 41.16 22.2925 41.0168 22.6596C40.8737 23.0268 40.8042 23.4185 40.8125 23.8125V47.375C40.8116 47.7693 40.8883 48.16 41.0385 48.5246C41.1886 48.8892 41.4092 49.2207 41.6875 49.5L54.0938 61.9375C54.6573 62.5011 55.4217 62.8177 56.2188 62.8177C57.0158 62.8177 57.7802 62.5011 58.3438 61.9375C58.9073 61.3739 59.224 60.6095 59.224 59.8125C59.224 59.0155 58.9073 58.2511 58.3438 57.6875L46.8125 46.1875V23.8125C46.821 23.408 46.7476 23.006 46.5966 22.6306C46.4457 22.2552 46.2205 21.9142 45.9344 21.6281C45.6483 21.342 45.3073 21.1168 44.9319 20.9658C44.5565 20.8149 44.1545 20.7415 43.75 20.75Z"
                        ></path>
                        </svg>
                    </div>
                    <div class="chargezen-tooltip-label">${getTranslation("subscription_details")}</div>
                    <div class="chargezen-tooltiptext">
                        <div class="chargezen-container-arrow chargezen-container-arrow--tl"></div>
                        <p>
                            ${getTranslation("subscription_details_description_html")}
                        </p>
                    </div>
                </div>
            </fieldset>
            `
        )

    }, [formData, translationFormData]
    )
    return (
        <>
            <div
                className="widget_html_container"
                dangerouslySetInnerHTML={{ __html: widgetHtml }}
            />
            <style dangerouslySetInnerHTML={{ __html: customStyle }} />
        </>
    );
}

export default SubscriptionWidgetHtml;
